export default __webpack_public_path__ + "static/media/facebook.1f45bd00.svg";